(function() {
	var inquiryTmpl = 
	'{{#each (item, index) in inquiryList}}' +
	'<li>' +
		'<span class="rdo-wrap btn-type4">' +
			'{{# if (index == 0) { #}}' +
			'<input type="radio" name="subsection" id="inquiry{{index}}" value="{{item.value}}" data-inquiry-name="{{item.name}}" data-error-msg="정확한 제품증상을 선택해 주세요." data-required="true" required>' +
			'{{# } else { #}}' +
			'<input type="radio" name="subsection" id="inquiry{{index}}" value="{{item.value}}" data-inquiry-name="{{item.name}}">' +
			'{{# } #}}' +
			'<label for="inquiry{{index}}"><span>{{item.name}}</span></label>' +
		'</span>' +
	'</li>' + 
	'{{/each}}';
	
	var filterTemplate = '<li>' +
			'<span class="rdo-wrap btn-type4">'+
				'<input type="radio" name="sympCd" id="topic{{index}}" data-name="{{name}}" value="{{value}}" data-group="{{value}}">' +
				'<label for="topic{{index}}"><span>{{name}}</span></label>' +
			'</span>' +
		'</li>';
	
	// var filterHeadTemplate =
	// 	'<li>'+
	// 	'<span class="rdo-wrap btn-type4">'+
	// 	'<input type="radio" name="topicrdo" id="topicrdo0" value="" data-group="A">'+
	// 	'<label for="topicrdo0">'+
	// 	'<span>{{name}}</span>'+
	// 	'</label>'+
	// 	'</span>'+
	// 	'</li>';
		
	var filterSubTemplate = '<option data-code="{{value}}" data-text="{{name}}" title="증상선택">{{name}}</option>';
	
	var serviceMenuTemplate = 
		'<li>'+
			'<a href="{{href}}" data-target="{{datatarget}}">{{name}}</a>'+
		'</li>';
	
	var validation;
	var validation_email;
	var validation_call;
	var validation_video;
	var validation_remote;
	var authManager;
	var dateUtil = vcui.date;
	var isLogin = lgkorUI.isLogin;
	var detect = vcui.detect;

	var $context = $(document);

	var reservation = {
		init: function() {
			var self = this;

			self.$cont = $('.contents');
			self.$searchModelWrap = self.$cont.find('.prod-search-wrap');
			self.$prodWrap = self.$cont.find('.prod-wrap');
			//보유에서 카테고리및 재품선텍시 보여지는 바
			//self.$selectedModelBar = self.$cont.find('.prod-selected-wrap');
			self.$selectedModelBar = self.$cont.find('.goods-selected-wrap');

			// BTOCSITE-62364 모델번호, 제조번호 입력
			self.$modelSearchBox = self.$searchModelWrap.find('#modelSearchBox'); // 모델명/제조번호 입력
			self.$modelSelectBox = self.$searchModelWrap.find('#modelSelectBox'); // 제품군 선택 

			self.$myModelWrap = self.$cont.find('.my-product-wrap');
			self.$myModelSlider = self.$myModelWrap.find('.my-product-slider');  //보유 제품이 없을경우때문에 추가
			
			//보유재품에서선택, 제품목록에서 선택 탭바
			self.$tabWrap = self.$cont.find('#tabs-prod');
			
			self.$submitForm = self.$cont.find('#submitForm');
			self.$completeBtns = self.$cont.find('.btn-group');
			self.$stepArea = self.$cont.find('#stepArea');
			self.$stepInquiry = self.$cont.find('#stepInquiryType');
			self.$stepInput = self.$cont.find('#stepInput');
			self.$saleInfoBox = self.$stepArea.find('#saleInfo');
			self.$salesDtWrap = self.$saleInfoBox.find('#salesDt');

			self.$inquiryBox = self.$cont.find('#inquiryBox');
			self.$inquiryListWrap = self.$cont.find('#inquiryList');
			self.$inquiryList = self.$inquiryListWrap.find('.rdo-list');
			self.$recordBox = self.$stepInput.find('#recordBox');
			self.$rcptNoBox = self.$stepInput.find('#rcptNoBox');
			
			self.$solutionsBanner = self.$stepInput.find('#solutionBanner');
			
			self.$calendarWrap = self.$cont.find('.calendar-area');
			self.$calendarDate = self.$calendarWrap.find('.date-wrap');
			self.$calendarTime = self.$calendarWrap.find('.time-wrap');
			
			self.$serviceceEmail = self.$cont.find('#service-email');   //1:1문의
			self.$servicecall = self.$cont.find('#service-call');   //전화상담관련
			self.$serviceremote = self.$cont.find('#service-remote');   //원격상담관련
			self.$servicevideo = self.$cont.find('#service-video');   //전화상담관련
			//이메일
			self.$userEmailWrap = $('.email-wrap');
			self.$email = $('#userEmail');
			self.$userEmailId = $('#userEmailId');
			self.$inquiryContent = self.$serviceceEmail.find('#inquiryContent');
			
			self.$modelBox = self.$cont.find('#model-box');
		   
			
			self.$authPopup = $('#certificationPopup');
			// BTOCSITE-13599 요금 및 보증기간 안내 팝업 수정
			self.warrantyGuide = $('#ratesWarrantyGuidePopup');
			
			self.$topicBox = $("#productProblems");
			self.$textarea = self.$topicBox.find('#addDesc textarea');
			self.$solutionsFilter = self.$topicBox.find('.section-box .topic-wrap .topics .rdo-list');  //증상 1 리스트
			self.$solutionsFilterSubtopic = self.$topicBox.find('.section-box .topic-wrap .sub-topic');
			self.$solutionsFilterSub1 = self.$solutionsFilterSubtopic.find('#stopic01');  //증상 2 리스트
			self.$solutionsFilterSub2 = self.$solutionsFilterSubtopic.find('#stopic02');  //증상 3 리스트
			
			self.$selectCategory = $('div.section.accord-wrap.prod-selected-box.prod-search-wrap');
			
			self.$menuList = $('#onlineServiceMenu');
			
			self.param = {};
			self.typeFlag = self.$searchModelWrap.data('typeFlag');
			self.resultUrl = self.$searchModelWrap.data('resultUrl');
			self.$cont.find('#route').val(detect.isMobile ? 'WWW2' : 'WWWW1');
			
			self.$btngroup = self.$cont.find('.btn-group.center.type-footer');
			self.setUserEmail(); //BTOCSITE-51309 1:1 문의 & 이메일 문의] 휴대폰 번호 입력 항목 추가
			self.replaceTitleText();
			self.bindEvent();

			//BTOCSITE-80487 고객지원 > 출장예약 > 모델명 입력 > 자동완성 미선택
			if(lgkorUI.getParameterByName('mpFlag') == 'Y'){
                self.$tabWrap.vcTab('select', 1);
            }

			//BTOCSITE-64390 구독 PDP 가전 구독 전화 상담 예약 개선 요청
			if(lgkorUI.getParameterByName('rentalCare') == 'y'){
				self.rentalCare = true;
			}
			
			// BTOCSITE-50788 고객지원] 서비스 메뉴 회원/로그인 정책 확대
			if (!lgkorUI.isLogin) {
				$('#loginEnterPopup').vcModal();
			} 
			$('.loginPopup').find('.ui_modal_close').on('click', function(){
				$(window).trigger("toastshow", '고객지원 홈으로 이동합니다.');
				setTimeout(function(){
					location.href = "/support";
				}, 100);
			});

			var register = {
                sympCd: {
                    required: true,
                    msgTarget: '.topic-msg',
                    errorMsg: '정확한 제품증상을 선택해 주세요.'
                },
                sympSubCode: {
                    required: true,
                    msgTarget: '.sub-topic-msg',
                    errorMsg: '정확한 세부 증상을 선택해 주세요.'
                },
                sympCodeThree: {
                    required: true,
                    msgTarget: '.three-topic-msg',
                    errorMsg: '정확한 세부 증상을 선택해 주세요.'
                }
			}
			
			//이메일
			var register_email = {
					privcyCheck_email: {
						required: true,
						msgTarget: '.err-block',
						errorMsg: '개인정보 수집 및 이용에 동의 하셔야 이용 가능합니다.'
					},
					subsection: {
						required: true,
						msgTarget: '.type-msg',
						errorMsg: '정확한 제품증상을 선택해 주세요.'
					},
					inquiryTitle: {
						required: true,
						maxLength: 40,
						msgTarget: '.err-block',
						errorMsg: '제목을 입력해 주세요.'
					},
					inquiryContent: {
						required: true,
						maxLength: 1000,
						msgTarget: '.err-block',
						errorMsg: '내용을 입력해 주세요.'
					},
					userName: {
						required: true,
						maxLength: 30,
						pattern: /^[가-힣\s]+$|^[a-zA-Z\s]+$/,
						msgTarget: '.err-block',
						errorMsg: '이름을 입력해 주세요.',
						patternMsg: '이름은 한글 또는 영문으로만 입력해 주세요.'
					},
					phoneNo: {
						required: true,
						minLength: 10,
						maxLength: 11,
						msgTarget: '.err-block',
						errorMsg: '정확한 휴대폰 번호를 입력해 주세요.',
						patternMsg: '정확한 휴대폰 번호를 입력해 주세요.',
						validate : function(value){
							return validatePhone(value);
						}
					},
					userEmailId: {
						required: true,
						pattern : /^(([a-z0-9_\.-]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
						minLength: 1,
						maxLength: 50,
						msgTarget: '.err-block',
						errorMsg: '이메일 주소를 입력해 주세요.',
						patternMsg: '올바른 이메일 형식이 아닙니다.',
						validate : function(value){
							var selectVal = $('#userEmailSelect option:selected').val();
							//var userEmail2 = $('#userEmail2').val();
							//var userEmailDir = $('#userEmailDirect').val();
							if(selectVal == "direct") {
								value;
							}else{
								value = value + "@" + selectVal;
							} 
							
							var _pattern = new RegExp(this.pattern);

							if( _pattern.test(value) == true) {
								if( value.split('@')[0].length <= 30 && value.split('@')[1].length <= 20) {
									return true;
								} else {
									return false;
								}
							} else {
								return false;
							}
						}
					},
					userEmailDirect:{
						required: true,
						//pattern : /^(([a-z0-9_\.-]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
						pattern: /^([\w\.\_\-])*[a-zA-Z0-9]+([\w\.\_\-])*([a-zA-Z0-9])+([\w\.\_\-])+@([a-zA-Z0-9]+\.)+[a-zA-Z0-9]{2,8}$/,
						minLength: 1,
						maxLength: 50,
						msgTarget: '.err-block',
						errorMsg: '이메일 주소를 입력해 주세요.',
						patternMsg: '올바른 이메일 형식이 아닙니다.',
						validate : function(value){
							var selectVal = $('#userEmailSelect option:selected').val();
							//var userEmail2 = $('#userEmail2').val();
							//var userEmailDir = $('#userEmailDirect').val();
							if(selectVal == "direct") value;
							else value = value + "@" + selectVal;
							
							var _pattern = new RegExp(this.pattern);

							if( _pattern.test(value) == true) {
								if( value.split('@')[0].length <= 30 && value.split('@')[1].length <= 20) {
									return true;
								} else {
									return false;
								}
							} else {
								return false;
							}
						}
					}
				};
			
			//전화
			var register_call = {
					privcyCheck_call: {
						required: true,
						msgTarget: '.err-block',
						errorMsg: '개인정보 수집 및 이용에 동의 하셔야 이용 가능합니다.'
					},
					userNm: {
						required: true,
						maxLength: 30,
						pattern: /^[가-힣\s]+$|^[a-zA-Z\s]+$/,
						msgTarget: '.err-block',
						errorMsg: '이름을 입력해 주세요.',
						patternMsg: '이름은 한글 또는 영문으로만 입력해 주세요.'
					},
					phoneNo: {
						required: true,
						minLength: 10,
						maxLength: 11,
						msgTarget: '.err-block',
						errorMsg: '정확한 휴대폰 번호를 입력해 주세요.',
						patternMsg: '정확한 휴대폰 번호를 입력해 주세요.',
						validate : function(value){
							return validatePhone(value);
						}
					}
				};
			
			//원격
			var register_remote = {
					privcyCheck_remote: {
						required: true,
						msgTarget: '.err-block',
						errorMsg: '개인정보 수집 및 이용에 동의 하셔야 이용 가능합니다.'
					},
					userNm: {
						required: true,
						maxLength: 30,
						pattern: /^[가-힣\s]+$|^[a-zA-Z\s]+$/,
						msgTarget: '.err-block',
						errorMsg: '이름을 입력해 주세요.',
						patternMsg: '이름은 한글 또는 영문으로만 입력해 주세요.'
					},
					phoneNo: {
						required: true,
						minLength: 10,
						maxLength: 11,
						msgTarget: '.err-block',
						errorMsg: '정확한 휴대폰 번호를 입력해 주세요.',
						patternMsg: '정확한 휴대폰 번호를 입력해 주세요.',
						validate : function(value){
							return validatePhone(value);
						} 
					}
				};
			
			//영상통화
			var register_video = {
					privcyCheck_video: {
						required: true,
						msgTarget: '.err-block',
						errorMsg: '개인정보 수집 및 이용에 동의 하셔야 이용 가능합니다.'
					},
					userNm: {
						required: true,
						maxLength: 30,
						pattern: /^[가-힣\s]+$|^[a-zA-Z\s]+$/,
						msgTarget: '.err-block',
						errorMsg: '이름을 입력해 주세요.',
						patternMsg: '이름은 한글 또는 영문으로만 입력해 주세요.'
					},
					phoneNo: {
						required: true,
						minLength: 10,
						maxLength: 11,
						msgTarget: '.err-block',
						errorMsg: '정확한 휴대폰 번호를 입력해 주세요.',
						patternMsg: '정확한 휴대폰 번호를 입력해 주세요.',
						validate : function(value){
							return validatePhone(value);
						} 
					}/* ,
					date: {
						required: true,
						msgTarget: '.err-msg',
						errorMsg: '날짜를 선택해 주세요.'
					},
					time: {
						required: true,
						msgTarget: '.err-msg',
						errorMsg: '시간을 선택해 주세요.'
					} */
				};
			
			var authOptions = {
				elem: {
					popup: '#certificationPopup',
					name: '#authName',
					phone: '#authPhoneNo',
					number: '#authNo'
				},
				register: {
					authName: {
						required: true,
						maxLength: 30,
						pattern: /^[가-힣\s]+$|^[a-zA-Z\s]+$/,
						msgTarget: '.err-block',
						errorMsg: '이름을 입력해 주세요.',
						patternMsg: '이름은 한글 또는 영문으로만 입력해 주세요.'
					},
					authPhoneNo: {
						required: true,
						minLength: 10,
						maxLength: 11,
						pattern: /^(010|016|011|017|018|019)\d{3,4}\d{4}$/,
						msgTarget: '.err-block',
						errorMsg: '정확한 휴대폰 번호를 입력해 주세요.',
						patternMsg: '정확한 휴대폰 번호를 입력해 주세요.',
						validate : function(value){
							return validatePhone(value);
						} 
					},
					authNo:{
						required: true,
						msgTarget: '.err-block',
						errorMsg: '인증번호를 입력해 주세요.',
					}
				}
			};

			
			// BTOCSITE-14892 동영상 첨부 기능 추가
			vcui.require(['ui/validation', 'ui/imageMovFileInput', 'support/common/searchModelNew.min'], function () {
				validation = new vcui.ui.CsValidation('#productProblems', {register:register});
				validation_email = new vcui.ui.CsValidation('div#service-email', {register:register_email});
				validation_call = new vcui.ui.CsValidation('div#service-call', {register:register_call});
				validation_video = new vcui.ui.CsValidation('div#service-video', {register:register_video});
				validation_remote = new vcui.ui.CsValidation('div#service-remote', {register:register_remote});
				validation_data = new vcui.ui.CsValidation('.step-area', {});
				// BTOCSITE-14892 동영상 첨부 기능 추가
				// BTOCSITE-15196 동영상 파일 첨부 관련 아이폰 동영상
				self.$cont.find('.ui_imageinput').vcImageMovFileInput({regex: /[?!,&^~]/});
				self.$cont.vcSearchModelNew(); 

				var url = location.search;

				if (url.indexOf("?") > -1) {                    
					var search = url.substring(1);
					var searchObj = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');

					if (searchObj.parts) {
						lgkorUI.setAcecounter('www.lge.co.kr/acecount/emailPartsView.do', '/acecount/emailPartsViewm.do');
						$('#stepInquiryType').find('[data-sub-category-name="케어용품/소모품"]').trigger('click');
					} else if (searchObj.simple) {
						lgkorUI.setAcecounter('www.lge.co.kr/acecount/emailMemberView.do', '/acecount/emailMemberViewm.do');
						$('#stepInquiryType').find('[data-sub-category-name="LG전자 회원"]').trigger('click');
					} else if (searchObj.mktModelCd) {
						lgkorUI.setAcecounter('www.lge.co.kr/acecount/emailMktView.do', '/acecount/emailMktViewm.do');
					}
				}
				
				if (!lgkorUI.isLogin) authManager = new AuthManager(authOptions);
				
				//self.bindEvent();
				self.$calendarDate.calendar({inputTarget:'#date'});
				self.$calendarTime.timeCalendar({inputTarget:'#time'});

				//self.keyword.init();

			});
		},
		// BTOCSITE-51309 1:1 문의 & 이메일 문의] 휴대폰 번호 입력 항목 추가
		setUserEmail: function(){
			var self = this;
			if(!lgkorUI.isLogin) return;

			var email = self.$email.val();
			if(vcui.isEmpty(email)) return;
			
			var emailId = email.substr(0, email.indexOf("@",0));
			var emailDomain = email.substr(email.indexOf("@",0)+1);
			//$('#userEmailId').val(emailId);
			
			var domainArr = [];
			$("#userEmailSelect option").each(function(){
				domainArr.push($(this).val());
			});
			
			if( vcui.array.include(domainArr, emailDomain) ){
				self.$userEmailId.val(emailId);
				$('#userEmailSelect select').vcSelectbox('value', emailDomain);
				$('#userEmailSelect select').vcSelectbox('update');
				self.$userEmailWrap.removeClass('no-mark');
			}else{
				//$('#userEmailDirect').val(emailDomain);
				self.$userEmailId.val(email);
				$('#userEmailSelect select').vcSelectbox('value', 'direct');
				$('#userEmailSelect select').vcSelectbox('update');
				//$('.input-direct').show();
			}
		},
		 // BTOCSITE-47599 로그인 후, 정보 '선택해 주세요' or '입력해 주세요' 부분 문구 정비
		replaceTitleText: function(){
			if(!lgkorUI.isLogin) return;

			var isUserNm = $('[name="userNm"]').val() != '',
				isPhoneNo= $('[name="phoneNo"]').val() != '';

			if(isUserNm && isPhoneNo) {
				var title = $('.tit.re-text');
				var text = title.eq(0).html();
				title.html(text.replace('입력해', '확인해'));
			}
		},
		loadEmail: function() {
			var self = this;
			var param = {
				category: $('#category').val(),
				subCategory: $('#subCategory').val(),
				modelCode: $('#modelCode').val(),
				serviceType: 'C'
			};
			$('#serviceType').val('C');
			var callUrl = "/support/emailInquiryCate.lgajax";
			lgkorUI.showLoading();
			lgkorUI.requestAjaxDataPost(callUrl, param, function(result) {
				var data = result.data;
				var result = data.inquiryList instanceof Array ? data.inquiryList.length : false;
				var html = '';
				
				if (result) {
					html = vcui.template(inquiryTmpl, data);
					self.$inquiryList.html(html);
					self.$inquiryBox.show();
					self.$completeBtns.show();
				} else {
					self.$inquiryBox.hide();
				}

				//self.nextStepInput();

				lgkorUI.hideLoading();
			});
			
		},
		nextStepInput: function() {
			var self = this;
			var summaryOpt = {
				product: [self.param.categoryNm, self.param.subCategoryNm, self.param.modelCode],
				reset: 'type'
			};
			self.$selectedModelBar.show();
			self.$completeBtns.show();

			self.$cont.vcSearchModelNew('updateSummary', summaryOpt);
		},
		loadCall: function() {
			var self = this;
			var param = {
				category: $('#category').val(),
				subCategory: $('#subCategory').val(),
				modelCode: $('#modelCode').val(),
				serviceType: 'C',
				productCode: $('#productCode').val(),
				phoneNo: '',
				zipId:'',
				userNm:'',
				topic:'',
				subTopic:''
			};
			$('#serviceType').val('C');
			lgkorUI.showLoading();
			var callUrl = "/support/reserve/possibleReserveDate";
			lgkorUI.requestAjaxDataPost(callUrl, param, function(result) {
				var data = result.data;
				self.setCalendar(data, "service-call");       

				// BTOCSITE-3629 add
				if (self.isRentalCarePath){
					$('input[data-topic-name="렌탈/케어 관련"]').trigger('click');
				}

				lgkorUI.hideLoading();
				
			});
			//약관동의 로그인시 
			if (lgkorUI.isLogin) {
				$('#service-call').find('.terms').hide();
				$('#privcyCheck_call').prop('checked', true);

			}else{
				$('#service-call').find('.terms').show();
				$('#privcyCheck_call').prop('checked', false);
			}
		},
		loadRemote: function() {
			var self = this;
			var param = {
				category: $('#category').val(),
				categoryNm: $('#categoryNm').val(),
				subCategory: $('#subCategory').val(),
				subCategoryNm: $('#subCategoryNm').val(),
				modelCode: $('#modelCode').val(),
				serviceType: 'E',
				productCode: $('#productCode').val(),
				phoneNo: '' 
			};
			$('#serviceType').val('E');
			lgkorUI.showLoading();
			var callUrl = "/support/reserve/possibleReserveDate";
			lgkorUI.requestAjaxDataPost(callUrl, param, function(result) {
				var data = result.data;
				self.setCalendar(data, "service-remote");
				lgkorUI.hideLoading();
			});
			//약관동의 로그인시 
			if (lgkorUI.isLogin) {
				$('#service-remote').find('.terms').hide();
				$('#privcyCheck_remote').prop('checked', true);

			}else{
				$('#service-remote').find('.terms').show();
				$('#privcyCheck_remote').prop('checked', false);
			}
		},
		loadVideo: function() {
			var self = this;
			var param = {
				category: $('#category').val(),
				subCategory: $('#subCategory').val(),
				modelCode: $('#modelCode').val(),
				serviceType: 'C',
				productCode: $('#productCode').val(),
				phoneNo: '' 
				
			};
			$('#serviceType').val('C');
			lgkorUI.showLoading();
			var callUrl = "/support/reserve/possibleReserveDate";
			lgkorUI.requestAjaxDataPost(callUrl, param, function(result) {
				var data = result.data;
				self.setCalendar(data,"service-video");
				lgkorUI.hideLoading();
			});
		  //약관동의 로그인시 
		  if (lgkorUI.isLogin) {
				$('#service-video').find('.terms').hide();
				$('#privcyCheck_video').prop('checked', true);

				
			}else{
				$('#service-video').find('.terms').show();
				$('#privcyCheck_video').prop('checked', false);
			}

		},
		setCalendar: function(data, service) {
			var self = this;
			if(data.resultFlag == 'Y'){
				var success = (data.dateList instanceof Array && data.dateList.length) ? true : false;
					fastDate = data.fastTime.substr(2,2) != "00" ? dateUtil.format(data.fastDate + '' + data.fastTime + '00', 'yyyy년 MM월 dd일 hh시 mm분') : dateUtil.format(data.fastDate + '' + data.fastTime + '00', 'yyyy년 MM월 dd일 hh시');
				if (success) {
					$('#'+service).find('.info-wrap .reser-info .point').html(fastDate);
					$('#fastdate').val(data.fastDate);
					$('#fasttime').val(data.fastTime);
					$('#'+service).find('.date-wrap').calendar('update', data.dateList);
					var target = $('#serviceName').val();
					$('#'+target).find('.check-info').find('.date').html(fastDate);
					$('#'+service).find('.section.date-info-wrap.accord-wrap').show();
					$('#'+service).find('.info-wrap').show();
					$('#'+service).find('.schedule-btn-wrap').show();
				}

			}else{
                //BTOCSITE-67419 구독 PDP 가전 구독 전화 상담 예약 개선 요청
				lgkorUI.alert("",  {title: data.resultMessage, ok: function(){
                    $('.select-service li').removeClass('on');
                    $('.service-include-wrap').hide();
                }});
			}

		},
		requestTime: function(selectdate) {
			var self = this;
			var url = self.$calendarWrap.data('timeUrl');
			var param = {
				serviceType: $('#serviceType').val(),
				productCode: $('#productCode').val(),
				category: $('#category').val(),
				subCategory: $('#subCategory').val(),
				date: selectdate
			};

			lgkorUI.showLoading();
			lgkorUI.requestAjaxDataPost(url, param, function(result) {
				var data = result.data;

				if (data.resultFlag == 'Y') {
					self.$calendarTime.timeCalendar('update', data.timeList);
					self.$calendarTime.find('.box-desc').hide();
					self.$calendarTime.find('.box-table').show();

					if ($(window).data('breakpoint').isMobile) {
						lgkorUI.scrollTo(self.$calendarTime.parent(), $('.prod-selected-wrap').outerHeight() + 100); // BTOCSITE-21157 고객지원 메뉴 - 포커스 이동 위치 수정
					}

				} else {
					if (data.resultMessage) {                            
						lgkorUI.alert("", {
							title: data.resultMessage
						});
					}
				}
				lgkorUI.hideLoading();
			});
		},
		// BTOCSITE-15196 동영상 파일 첨부 관련 아이폰 동영상
		renameFile: function(file){
			var name = file.name.substring(0, file.name.lastIndexOf("."));
			var ext = file.name.split('.').pop();
			var regex = /[?!,.&^~]/;

			if(regex.test(name)){
				name = vcui.string.replaceAll(name, regex, '_');
			}
			
			var newFileName = name+'.'+ext;
			var formData = new FormData();
				formData.append('file', file, newFileName);
				
			return formData.get('file');
		},
		requestComplete: function() {
			var self = this;
			var url = self.$submitForm.data('ajax');
			var param;
			var formData = new FormData;
			
			var target = $('#serviceName').val();
			 switch(target) {
				 case "service-email" :
					//이메일
					param = validation_data.getAllValues();
				 break;
				 case "service-call" :
					//전화
					param = validation_data.getAllValues();
					param.date = $('#date').val();
					param.time = $('#time').val();
				 break;
				 case "service-video" :
					//영상
					param = validation_data.getAllValues();
					param.date = $('#date').val();
					param.time = $('#time').val();
					param.svcTypeSub="[영상상담 서비스]";
				 break;
				 case "service-remote" :
					//원격
					param = validation_data.getAllValues();
					param.date = $('#date').val();
					param.time = $('#time').val();
				 break;
				 default :
			 }
			param.sympCd = $('#sympCd').val();
			param.sympSubCode = $('#sympSubCode').val();
			param.sympCodeThree = $('#sympCodeThree').val();
			param.marketingUseAgreeYn = "Y";
			param.userNm = $('#'+target).find('[name="userNm"]').val();
			param.phoneNo = $('#'+target).find('[name="phoneNo"]').val();
			param.typeFlag = self.typeFlag;
			param.topLoginFlag = lgkorUI.isLogin ? 'Y' : 'N';//로그인 체크
			
			
			//param.userEmail = param.userEmail + '@' + param.userEmail2select;
			var selectVal = $('#userEmailSelect option:selected').val();
			//var userEmail2 = $('#userEmail2').val();
			var userEmail = $('#userEmailId').val(); 
			//var userEmailDir = $('#userEmailDirect').val();
			// BTOCSITE-51309 1:1 문의 & 이메일 문의] 휴대폰 번호 입력 항목 추가
			//if(selectVal == "direct") param.userEmailId = userEmail + "@" + userEmailDir;
			   // else param.userEmail = userEmail + "@" + selectVal;

			
			
							
			for (var key in param) {
				// BTOCSITE-15196 동영상 파일 첨부 관련 아이폰 동영상
				(key.includes('imageFile') && param[key]) ? param[key] = self.renameFile(param[key]) : '';    
				formData.append(key, param[key]);
			}
			
			lgkorUI.showLoading();
			if(target == 'service-email'){
				lgkorUI.requestAjaxFileData(url, formData, function(result) {
					var data = result.data,
						param = result.param;

					// 로그인 체크
					if(data.loginCheckFlag == 'N') {
						lgkorUI.hideLoading();
						$('#loginPopup').vcModal();
						return;
					}

					if (data.resultFlag == 'Y') {
						for (var key in param) {
							var $hidden = document.createElement("input");
							$hidden.type = "hidden";
							$hidden.name = key;
							$hidden.value = param[key];
							self.$submitForm.append($hidden);
						}
						self.$submitForm.submit();
					} else {
						lgkorUI.hideLoading();
						
						if (data.resultMessage) {
							lgkorUI.alert("", { title: data.resultMessage });
						}
					}
				}, 'POST');
			}else{

				// BTOCSITE-51736 실제 예약 시간 보다 더 빠른 연락을 원하는 고객 취향 반영
				var callSoonerCheck = $('#resCallCheckPopup').find('input:checkbox').prop('checked');
				
				if(callSoonerCheck){
					param.callSoonerYn = 'Y';
				}else{
					param.callSoonerYn = 'N';
				}
				
				//BTOCSITE-71560 고객지원 > 상담예약 > PDP에서 인입시 Smile+ 전달사항에 "LGE.com" 추가
				//BTOCSITE-88763 LGE.COM 상담예약 2Depth 증상 선택시 Smile+ 전달사항에 "LGE.com" 텍스트 설정
				var sympSubCodeNm = $('#sympSubCodeNm').val();
				if(self.rentalCare && (sympSubCodeNm == '계약 관련' || sympSubCodeNm == '가전구독 구매문의' || sympSubCodeNm == '구독료')){
					param.rentalCare = "Y";
				}


				lgkorUI.showLoading();
				lgkorUI.requestAjaxDataPost(url, param, function(result) {
					var data = result.data;
					var param = result.paramVO;

					// 로그인 체크
					if(data.loginCheckFlag == 'N') {
						lgkorUI.hideLoading();
						$('#loginPopup').vcModal();
						return;
					}

					if (data.resultFlag == 'Y') {
						$('#acptNo').val(data.acptNo);
						for (var key in param) {
							var $hidden = document.createElement("input");
							$hidden.type = "hidden";
							$hidden.name = key;
							$hidden.value = param[key];
							self.$submitForm.append($hidden);
						}
						$('[name="userNm"]').val(param.userNm);
						$('[name="phoneNo"]').val(param.phoneNo);
						
						self.$submitForm.submit();
					} else {
						lgkorUI.hideLoading();
						
						if (data.resultMessage) {
							lgkorUI.alert("", {
								title: data.resultMessage
							});
						}
					}
				}, 'POST');
			}
		},
		reset: function() {
			var self = this;
			self.param = {};
			self.$prodWrap.show();
			self.$recordBox.hide();
			self.$rcptNoBox.hide();
			self.$inquiryBox.hide();
			self.$inquiryList.empty();
			self.$completeBtns.hide();
			self.$stepInput.hide();
			//self.$selectedModelBar.hide();
			self.$stepInput.find('[name=subsection]').prop('checked', false);
			self.$stepInput.find('[name=record]').eq(0).prop('checked', true);
			self.$stepInput.find('#cRcptNo').val('');
			self.$stepInput.find('#inquiryTitle').val('');
			self.$stepInput.find('#inquiryContent').val('');
			self.$stepInput.find('[name=buyingdate]').closest('.conts').find('.form-text').remove();
			self.$stepInput.find('[name=buyingdate]').prop('checked', false);
			self.$stepInput.find('#content').val('');
			$('#buyingdate').val("");

			self.$salesDtWrap.find('.text').hide();
			self.$salesDtWrap.find('.rdo-list-wrap').hide();
			
			//BTOCSITE-2409 [긴급] 이메일문의 > 특정 문의 시 컬럼 추가
			$('#orderNo').hide();
			$('#orderNo').find('input').val('')
			$('#partNo').hide();
			$('#partNo').find('input').val('')
			// BTOCSITE-51736 실제 예약 시간 보다 더 빠른 연락을 원하는 고객 취향 반영
			$('#resCallCheckPopup').find('input:checkbox').prop('checked', false);

			//BTOCSITE-62364 모델번호, 제조번호 입력
			//모델명/제조번호
			self.delModelValue();
			$('.prod-model-box .btn-prod-next').prop('disabled', true);
			
			//BTOCSITE-64390 구독 PDP 가전 구독 전화 상담 예약 개선 요청
			self.preLoad = false;
			self.rentalCare = false;
			
			if (!lgkorUI.isLogin) {
				//self.$stepInput.find('#userName').val('');
				//self.$stepInput.find('#userEmailId').val('');
				// BTOCSITE-51309 1:1 문의 & 이메일 문의] 휴대폰 번호 입력 항목 추가
				$('[name="userName"]').val(''); //이메일
				$('[name="userNm"]').val('');
				$('[name="phoneNo"]').val('');
				$('#userEmailId').val('');
				$('#userEmailSelect select').vcSelectbox('value', '');
				//$('#userEmailDirect').val('');
			}

			if(lgkorUI.isLogin){
				// BTOCSITE-47599 로그인 후, 정보 '선택해 주세요' or '입력해 주세요' 부분 문구 정비
				self.$saleInfoBox.find('.tit-wrap .tit').text('제품 구매 정보를 입력해 주세요');
			}

			$('.service-include-wrap').hide();
			$('.change-dt').hide();
			$('.change-complete').hide();
			$('.btn-complete').hide();

			self.$solutionsFilterSub1.hide();
			self.$solutionsFilterSub2.hide();
			
			validation.reset();
			validation_email.reset();
			validation_call.reset();
			validation_video.reset();
			validation_remote.reset();
			self.$calendarDate.calendar('reset');
			self.$calendarTime.timeCalendar('reset');
			self.$cont.find('.ui_all_checkbox').vcCheckboxAllChecker('setAllNoneChecked');
			self.$cont.find('.ui_textcontrol').trigger('textcounter:change', { textLength: 0 });
			self.$cont.find('.ui_imageinput').vcImageMovFileInput('removeAll'); // BTOCSITE-14892 동영상 첨부 기능 추가
			
			if (!self.$myModelSlider.find('ul').children().length) {
				 $('#tabs-prod').hide();
				 $('.my-product-wrap.type-list').hide();
				return;
			}else{
				 $('#tabs-prod').show();
				 $('.my-product-wrap.type-list').show();
			}
			
			$('#stepInput').removeClass('active');
			$('#stepInput').hide();
			$('#onlineServiceMenu').hide();
		},
		DataSearchTopic: function()  {	        //1댑스 증상 조회 모댈 선택시 조회  댑스
			var self = this;
			var symp1url = "/support/commonModelSelected.lgajax?";
			var topicparam = {};
			$.extend(topicparam, {
					category:      $('#category').val(),
					categoryNm:    $('#categoryNm').val(), 
					subCategory:   $('#subCategory').val(),
					subCategoryNm: $('#subCategoryNm').val(), 
					modelCode:     $('#modelCode').val(),
					productCode:   $('#productCode').val(),
					salesModelCode:   $('#salesModelCode').val(),
					serviceType: "C",
					typeFlag: "counselFlag"
				});
			lgkorUI.showLoading();
			lgkorUI.requestAjaxData(symp1url, topicparam, function(result) {
				self.setFilter(result);
				lgkorUI.hideLoading();
			},'GET'); 
			//$('.err-msg.topic-msg').html("정확한 제품증상을 선택해 주세요.");
		},
		mktServiceList:function(){
			var self = this;
			var url = "/support/reserve/mktServiceList.lgajax";
			var param = {categoryId:$("#subCategory").val()};

			lgkorUI.showLoading();
			lgkorUI.requestAjaxDataPost(url, param, function(result){
				var data = result.serviceMenuList
				var html="";
				var menuArr = data instanceof Array ? data : [];
				if (menuArr.length) {
					var html = '';
					menuArr.forEach(function(item) {
						//제품정보 추가전달
						var data = self.param;
						item.href= '#'+item.datatarget
						html += vcui.template(serviceMenuTemplate, item);
					});
					self.$menuList.find('ul').html(html);
				}
				lgkorUI.hideLoading();	
			},'POST');
		},
		setFilter: function(datalist) {
			var self = this;
			var param = self.param,
				filterArr = datalist.data.topicList instanceof Array ? datalist.data.topicList : [],
				htmlPC = '';
			
			if (filterArr.length) {
				self.$solutionsFilter.empty();
				// self.$solutionsFilter.html(vcui.template(filterHeadTemplate, {}));

				filterArr.forEach(function(item, index) {
					item.index = index.toString(); // id값 으로 index 추가
					item.active = item.name == param.topicNm ? true : false; 
					htmlPC += vcui.template(filterTemplate, item);
				});
				self.$solutionsFilter.html(htmlPC);
			} else {
				self.$solutionsFilter.empty();
			}
		},
		// BTOCSITE-62364 모델번호, 제조번호 입력
        // ##### 제조번호 규칙 #####
        // 제조번호 자리수는 10자리에서 18자리까지이다. 숫자3자리로 시작한다.
        // 1. 자리수가 14자리 이하일 때는, 숫자3자리 + 숫자알파벳 7~11자리 이다. 
        //    패턴 : /^[0-9]{3}[A-Za-z0-9]{7,11}$/
        // 2. 자리수가 15자리에서 18자리 이하일 때는, 숫자3자리+ 숫자알파벳 9~11자리 + 숫자 1~4자리
        //    패턴 : /^[0-9]{3}[A-Za-z0-9]{9,11}[0-9]{1,4}$/

		validateModelSelectBox: function() {
			// 모델명/제조번호 
			var self = this;
            var $msg = self.$modelSearchBox.find('.success-msg');
            var $errmsg = self.$modelSearchBox.find('.success-msg.error');
			var snVal = self.$modelSearchBox.find('input[name="sn"]').val();
			var searchVal = self.$modelSearchBox.find('#search').val();
			var $cateWrap = self.$modelSearchBox.find('.cate-wrap');
			var $prodBtn = self.$modelSearchBox.find('.btn-prod-next');
			
			var modelCode = $('#modelCode').val();
			var salesModelCode = $('#salesModelCode').val();
			var categoryNm = $('#categoryNm').val();
			var subCategoryNm = $('#subCategoryNm').val();

			var less = /^[0-9]{3}[A-Za-z0-9]{7,11}$/.test(snVal); //자리수가 14자리 이하일 때는, 숫자3자리 + 숫자알파벳 7~11자리
			var over = /^[0-9]{3}[A-Za-z0-9]{9,11}[0-9]{1,4}$/.test(snVal); //자리수가 15자리~18자리 이하일 때는, 숫자3자리+ 숫자알파벳 9~11자리 + 숫자 1~4자리
			var isValidSn = false;
			var isValidModel = false;
			var isValidCate = false;
			var isCate = categoryNm != '' && subCategoryNm != '';

            if(snVal == '') {
				$prodBtn.prop('disabled', true);
                return;
            };

			if(less || over){
				isValidSn = true;
                $msg.show();
                $errmsg.hide();
				
			}else{
                $msg.hide();
                $errmsg.show();
			}

			if(modelCode == searchVal && salesModelCode != '' &&  modelCode != '' && searchVal != '' && isCate){
				isValidModel = true;
			}
			
			if(modelCode != searchVal && salesModelCode == '' && modelCode == '' && searchVal != '' && isCate){
				isValidCate = true;
			}
			
			if(modelCode != searchVal && searchVal != '' && isValidSn){
				$cateWrap.show();
			}else{
				$cateWrap.hide();
			}
			
			if(searchVal != '' && snVal != '' && isValidSn && (isValidModel || isValidCate)){

				//버튼 활성화
				$prodBtn.prop('disabled', false);
			}else{
				$prodBtn.prop('disabled', true);
			}
		},
        delModelValue: function() {
            var self = this;
            $('#categoryNm').val("");
            $('#subCategoryNm').val("");
            $('#category').val("");
            $('#subCategory').val("");
            $('#modelCode').val("");
            $('#productCode').val("");
            $('#salesModelCode').val("");
            $('#serialNumber').val("");
            //모델명/제조번호
            self.$modelSearchBox.find('[class^="success-msg"]').hide();
			self.$modelSearchBox.find('.cate-wrap').hide();
            self.$modelSearchBox.find('[id="sn"]').val("");
            self.$modelSearchBox.find('[id="search"]').vcInputClearButton('updateVal', '');
            self.$modelSearchBox.find('[id="prodCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
            self.$modelSearchBox.find('[id="prodSubCategorySelect"]').children('option:not(:first-child)').remove();
            self.$modelSearchBox.find('[id="prodSubCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
            //제품군 
            self.$modelSelectBox.find('[id="categorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
            self.$modelSelectBox.find('[id="subCategorySelect"]').children('option:not(:first-child)').remove();
            self.$modelSelectBox.find('[id="subCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');

        },
		checkTextarea: function(target, nextTarget) {
			var $target = $(''+target);
			var $nextTarget = $(''+nextTarget);

			var numbers = $target.val().replace(/[^0-9]/g, "");
			var title = '<p>혹시 전달사항에 개인 정보(전화번호, 주소 등)가 포함되어 있나요?<br>한 번 더 체크해 주세요.</p>';
			if(numbers.length >= 11){
				lgkorUI.confirm('', {
					typeClass: 'type2',
					title: title,
					okBtnName: '개인 정보 없음',
					cancelBtnName: '수정하기',
					ok:function(){
						setTimeout(function(){
							lgkorUI.scrollTo($nextTarget);
							$nextTarget.focus();
						}, 100);
					},
					cancel:function(){ 
						setTimeout(function(){
							numbers = '';
							$target.focus();
						}, 500);
					},
				});
			}
		},
		bindEvent: function() {

			var self = this;

			// 모델 선택 & 문의 재선택
			self.$cont.on('complete', function(e, data) {

				if(!lgkorUI.isLogin) return; //BTOCSITE-62364 모델번호, 제조번호 입력

				self.model = data;
				var param = data;
				lgkorUI.requestAjaxDataPost(self.resultUrl, param, function(result) {
					var resultData = result.data;
					self.$cont.vcSearchModelNew('updateSummary', {
						product: [data.categoryNm, data.subCategoryNm, data.modelCode],
						isMyProduct: $('#isMyProduct').val(),
						reset: 'product'
					});

					if (!!resultData.warrantyText && resultData.warrantValue.toString()) {
						$('#buyingdate').val(resultData.warrantValue);
						self.$salesDtWrap.find('.text').html(resultData.warrantyText);
						self.$salesDtWrap.find('.text').show();
						//self.$salesDtWrap.children().eq(1).hide()
						self.$salesDtWrap.find('.rdo-list-wrap').hide();
					   
						// BTOCSITE-47599 로그인 후, 정보 '선택해 주세요' or '입력해 주세요' 부분 문구 정비
						self.$saleInfoBox.find('.tit-wrap .tit').text('제품 구매 정보를 확인해 주세요');
					} else {
						// $('[name=buyingdate]').closest('.conts').find('.form-text').remove();
						self.$salesDtWrap.find('[name=buyingdate]').prop('checked', false);
						self.$salesDtWrap.find('[name=buyingdate]').closest('.rdo-list-wrap').show();
						self.$salesDtWrap.find('.text').hide();
					}

					self.setFilter(result); //증상
					//BTOCSITE-64390 구독 PDP 가전 구독 전화 상담 예약 개선 요청
					if(self.rentalCare && self.preLoad){
						setTimeout(function(){
							$('#topicList li').find("input[data-name='가전/서비스 구독']").trigger('click');
							lgkorUI.scrollTo($('#productProblems'));
						}, 100);
					}
					self.$prodWrap.hide();
					self.$myModelWrap.hide(); // 제품 리스트 은폐
					self.$selectedModelBar.show(); // 플로팅바 노출
					self.$stepArea.show(); // 정보 입력창 노출
					
					// var target = $('.product-group');
					// var itemCnt = target.find('ul li').length;
					
					lgkorUI.hideLoading();
				});

				self.param = $.extend(true, self.param, data);
				self.$topicBox.addClass('open');
				self.$tabWrap.hide();
				if (data.productCode || data.mktModelCd) {
					//self.loadEmail();
					self.preLoad = true;
					$('[data-product-only]').show();
				} else {
					self.$inquiryBox.hide();
					$('[data-product-only]').hide();
					self.nextStepInput();
				}
				//제품별 가능한 상담목록 조회
				self.mktServiceList();
				$('#stepInput').addClass('active');
				$('#stepInput').show();
			}).on('reset', function() {
				self.reset();
			});

			vcui.PubSub.on('completeSummary', function (e, data) {
                var param = data;
				self.param = $.extend(true, self.param, data);
				
				// self.$salesDtWrap.find('.rdo-list-wrap').show();
				self.$topicBox.addClass('open');
				self.$selectedModelBar.show();

				//제품별 가능한 상담목록 조회
				self.mktServiceList();

				//BTOCSITE-91187 고객지원 > 서비스 예약 > 모델명, 제조번호 입력 시 OCR 제공
                setTimeout(function(){
                    self.validateModelSelectBox();
                }, 200);
			});

            self.$selectedModelBar.on('keyup', '.btn-reset', function() {
                lgkorUI.focusFirstElement('.container'); //BTOCSITE-94858 [모니터링][웹앱 접근성 개선활동] 고객지원
            });

            self.$tabWrap.on('click', function() {
                var index = self.$tabWrap.vcTab("getSelectIdx");
                if(index.toString() == '0'){
                    self.delModelValue(); //BTOCSITE-62364 모델번호, 제조번호 입력
                }
            });

			//BTOCSITE-2409 [긴급] 이메일문의 > 특정 문의 시 컬럼 추가
			$('.desc-btn').find('button[data-sub-category-name]').on('click', function(e){
				var $this = $(this);
				var _subCategory = $this.data('sub-category-name').trim()

				if( _subCategory == "케어용품/소모품" || _subCategory == "구매문의") {
					
					$('#orderNo').show();
					$('#partNo').show();
				}
			});

			// 문의 유형 선택 시
			self.$inquiryBox.on('change', '[name=subsection]', function() {
				if ($(this).data('inquiryName') == 'A/S') {
					self.$recordBox.show();    
				} else {
					self.$recordBox.hide();
					self.$recordBox.find('input[type=radio]').eq(0).prop('checked', true);
					self.$rcptNoBox.hide();
					self.$rcptNoBox.find('input').val('');
				}

				validation_email.reset(['cRcptNo']);
				validation_call.reset(['cRcptNo']);
				validation_video.reset(['cRcptNo']);
				validation_remote.reset(['cRcptNo']);
			});

			// 상담/서비스 이력 선택 시
			self.$recordBox.on('change', '[name=record]', function() {
				if ($(this).val() == '0') {
					self.$rcptNoBox.hide();
					self.$rcptNoBox.find('input').val('');
					validation_email.reset(['cRcptNo']);
					validation_call.reset(['cRcptNo']);
				} else {
					self.$rcptNoBox.show();
				}
			});

			// 날짜 선택
			self.$calendarDate.on('dateselected', function(e, date) {
				$('#date').val(date);
				var target = $('#serviceName').val();
				switch(target) {
					 case "service-call" :
						 //전화
						validation_call.validate(['date']);
					 break;
					 case "service-video" :
						//영상
						validation_video.validate(['date']);
					 break;
					 case "service-remote" :
						//원격
						validation_remote.validate(['date']);
					 break;
					 default :
				 }
				
				 $('#'+target).find('.change-complete').hide();
				self.requestTime(date);
				
			});

			// 시간 선택
			self.$calendarTime.on('timeselected', function(e, date) {
				$('#time').val(date);
				var target = $('#serviceName').val();
				switch(target) {
					 case "service-call" :
						 //전화
						validation_call.validate(['time']);
					 break;
					 case "service-video" :
						//영상
						validation_video.validate(['time']);
					 break;
					 case "service-remote" :
						//원격
						validation_remote.validate(['time']);
					 break;
					 default :
				 }
				 var fdate = dateUtil.format($('#date').val() + '' + $('#time').val() + '00', 'yyyy년 MM월 dd일 hh시 mm분');
				$('#'+target).find('.check-info').find('.date').html(fdate);
				$('#'+target).find('.change-complete').show();
				$('#'+target).find('.btn-complete').show();
			});

			// 신청 완료
			self.$completeBtns.find('.btn-confirm').on('click', function() {
				var result;
				var target = $('#serviceName').val();
				 switch(target) {
					 case "service-email" :
						//이메일
						 result = validation_email.validate();
						if($('#inquiryList').find('input[type=radio]:checked') == 0){  //문의 유형 선택관련 채크
							$('.err-msg.type-msg').show();
							return;
						}
					 break;
					 case "service-call" :
						//전화
						 result = validation_call.validate();
					 break;
					 case "service-video" :
						//영상
						 result = validation_video.validate();
					 break;
					 case "service-remote" :
						//원격
						 result = validation_remote.validate();
					 break;
					 default :
				 }
				// BTOCSITE-51309 1:1 문의 & 이메일 문의] 휴대폰 번호 입력 항목 추가
				//result.userEmail = result.userEmail + '@' + result.userEmail2select;
				if(target == "service-email") { //이메일 상담일 경우
					self.$submitForm.data('ajax','/support/emailInquirySend.lgajax');
					self.$submitForm.attr('action','/support/email-inquiry-complete');	
					if (result.success == true) {    
						//  BTOCSITE-45312 이메일 상담] ERMS 이슈 대응 건
						// BTOCSITE-68966 고객지원 > EMS 선셋에 따른 이메일문의 수정
						var msg = "답변은 ‘예약 조회/변경’ 메뉴에서 확인하실 수 있습니다. (단, 답변일로부터 1개월간 확인 가능)";
						lgkorUI.confirm(msg, {
							title: '문의 하시겠습니까?',
							okBtnName: '확인',
							cancelBtnName: '취소',
							ok: function() {
								self.requestComplete();
							}
						},$(this) || '');
					}
				}
				else { //전화,영상,원격 상담일 경우
					switch(target) {
						case "service-call" :
						   //전화
							self.$submitForm.data('ajax','/support/reserve/reserveServiceSubmit.lgajax');
							self.$submitForm.attr('action','/support/request-call-reservation-complete');
						break;
						case "service-video" :
						   //영상
							self.$submitForm.data('ajax','/support/reserve/reserveServiceSubmit.lgajax');
							self.$submitForm.attr('action','/support/video-consulting-reservation-complete');
						break;
						case "service-remote" :
						   //원격
							self.$submitForm.data('ajax','/support/reserve/reserveServiceSubmit.lgajax');
							self.$submitForm.attr('action',"/support/remote-call-reservation-complete");
						break;
						default :
					}
					if (result.success == true) {   
						
						// BTOCSITE-51736 실제 예약 시간 보다 더 빠른 연락을 원하는 고객 취향 반영
						//BTOCSITE-94858 [모니터링][웹앱 접근성 개선활동] 고객지원
						$('#resCallCheckPopup').vcModal({opener:$(this)});
						
						/* 
						lgkorUI.confirm('', {
							title:'예약 하시겠습니까?',
							okBtnName: '확인',
							cancelBtnName: '취소',
							ok: function() {
								if(lgkorUI.isLogin){
									self.requestComplete();
										 
								}else{
									authManager.open(function() {
										$('#authName').val($('#'+target).find('#userNm').val()).prop('readonly', true);
										$('#authPhoneNo').val($('#'+target).find('#phoneNo').val()).prop('readonly', true);  
									});
								}
							},
							cancel: function() {
								$('div#schedule-btn-wrap').show();
							}
						});   
						*/
						
						
					}
				}
			});
			
			// BTOCSITE-51736 실제 예약 시간 보다 더 빠른 연락을 원하는 고객 취향 반영
			$('#resCallCheckPopup').find('.btn-ok').on('click', function() {
				if(lgkorUI.isLogin){
					
					$('#resCallCheckPopup').vcModal('hide'); // BTOCSITE-61104 상담이력 접수 팝업 개선
					self.requestComplete();
							
				}else{
					authManager.open(function() {
						$('#authName').val($('#'+target).find('[name="userNm"]').val()).prop('readonly', true);
						$('#authPhoneNo').val($('#'+target).find('[name="phoneNo"]').val()).prop('readonly', true);  
					});
				}
			});
			// BTOCSITE-51736 실제 예약 시간 보다 더 빠른 연락을 원하는 고객 취향 반영
			$('#resCallCheckPopup').find('.ui_modal_close').on('click', function() {
				$('#resCallCheckPopup').find('input:checkbox').prop('checked', false);
			});
			

			// 인증문자 보내기
			self.$authPopup.find('.btn-send').on('click', function() {
				authManager.send(this);
			});

			// 인증 완료하기
			self.$authPopup.find('.btn-auth').on('click', function() {
				authManager.confirm(this, function(success, result) {
					success && self.requestComplete();
				});
			});

			$(document).on('click', '.btn_ui_outlink', function(){
				var $this= $(this);
				var $popup = $this.closest('article.lay-wrap');

				$popup.vcModal('hide');
			});
			//BTOCSITE-8855 s
			$(document).on('click', '.faq-link a', function(e){
				if(isApp()) {
					e.preventDefault();
					var appUrl = $(this).attr('href');
					if (!(appUrl.match('https://'))) {
						appUrl = 'https://'+window.LGEAPPHostName+appUrl;
					} 
					if(vcui.detect.isIOS){
						var jsonString = JSON.stringify({'url': appUrl, 'command':'sendOutLink'});
						webkit.messageHandlers.callbackHandler.postMessage(jsonString);
					} else {
						android.openLinkOut(appUrl);
					}
				} 
			})
			//BTOCSITE-8855 e
			
			// BTOCSITE-13601 모델명 확인 방법 > 이미지 확대 추가
			var $imgView = $('.btn-img-view');
			$('#select2').on('change', function(){
	
				// 이미지가 없는 경우 no-img 삭제
				if(!(lgkorUI.NO_IMAGE_MODEL_NAME != $imgView.find('img').attr('src'))) {
					$imgView.find('img').removeClass('no-img');
				}
			});

			// BTOCSITE-13601 모델명 확인 방법 > 이미지 확대 추가
			$imgView.on('click', function(e) {
				e.preventDefault();
			
				if($(this).find('img').hasClass('no-img')) return;
	
				var domain=location.origin;
				var agent = navigator.userAgent;
				var imgUrl=domain + $(this).attr('href');
				var imgAlt = $(this).find('img').attr('alt');
				if(!vcui.detect.isMobileDevice){
					window.open(imgUrl, '', '');
					return
				}

				var currOption = $('#select2 option:selected');
				var popTitle = currOption.hasClass('placeholder') ? '모델명 확인 방법' : currOption.text();
				var $zoomPopup = $('#imgZoomPopup');
				var $zoomImg = $('#imgZoomPopup img');
				$zoomImg.attr('src', imgUrl);
				$zoomImg.attr('alt', imgAlt);

				$zoomPopup.find('.tit').html('<span>'+popTitle+'</span>');
				$zoomPopup.vcModal('open');
			});
			// 상담 선택
			self.$menuList.find('.select-service ul').on('click', 'a', function(e, data){

				//$('.service-include-wrap').hide();
				$(this).parent().addClass('on').siblings().removeClass('on');
				$('.change-dt').hide();
				$('.change-complete').hide();
				$('.btn-complete').hide();
				
				var previous = $('#serviceName').val();
				var target = e.currentTarget.dataset.target;
				var position = $('#onlineServiceMenu').offset().top;
				var result = validation.validate(['sympCd', 'sympSubCode', 'sympCodeThree']);
				if(!result.success){
					return;
				}
				
				//초기화 처리
				if(previous != ""){
					
					$('#'+previous).find('.change-dt').hide();
					$('#'+previous).find('.change-complete').hide();
					$('#'+previous).find('.btn-complete').hide();
					
					validation_email.reset();
					validation_call.reset();
					validation_video.reset();
					validation_remote.reset();
					self.$calendarDate.calendar('reset');
					self.$calendarTime.timeCalendar('reset');
					self.$cont.find('.ui_all_checkbox').vcCheckboxAllChecker('setAllNoneChecked');
					self.$cont.find('.ui_textcontrol').trigger('textcounter:change', { textLength: 0 });
					self.$cont.find('.ui_imageinput').vcImageMovFileInput('removeAll'); // BTOCSITE-14892 동영상 첨부 기능 추가
				}
				
				$('#serviceName').val(target);
				switch(target) {
					case "service-email" :
						self.loadEmail();
						$('[data-product-only]').show();
						$('textarea#inquiryContent').val($('textarea#content').val());
						$('textarea#inquiryContent').trigger('textcounter:change', { textLength: $('textarea#content').val().length });
						   break;
					case "service-call" :
						self.loadCall();
						break;
					case "service-video" :
						self.loadVideo();
						break;
					case "service-remote" :
						self.loadRemote();
						break;
					default :
				}
				$('.service-include-wrap').hide();
				$('#'+target).show();
				
				$('html, body').animate({ scrollTop: position }, 100);
				//로그인시 약관동의
				   
				if ($('.online-service').data('login') == 'Y'){
					$('#' + target).find('.terms').hide();
				}else{
					$('#' + target).find('.terms').show();
				}
				
				
			});

			// 이메일 선택 시
			function selectValCheck(val) {
				if(val == "direct") {
					self.$userEmailWrap.addClass('no-mark');
				}
				else {;
					self.$userEmailWrap.removeClass('no-mark');
				}
			}

			$('#userEmailSelect select').on('change', function(){
				var val = $(this).val();
				selectValCheck(val);
			});

			// $('.input-direct input').on('blur focusout', function () {
			// 	validation_email.validate(["userEmailId"]);
			// });
			
			// BTOCSITE-51309 1:1 문의 & 이메일 문의] 휴대폰 번호 입력 항목 추가
			$('#userEmailId, #userEmailSelect select').on('change',function(e, data){// 이메일 변경 시
				var userEmailId = $('#userEmailId').val();
				var selectVal = $('#userEmailSelect option:selected').val();
				//var userEmailDirect = $('#userEmailDirect').val();
				
                userEmailId = vcui.string.replaceAll(userEmailId, ' ', '');

				if(selectVal == "direct"){
					//$('#userEmail').val(userEmailId);
					self.$email.val(userEmailId);
				}else{
					self.$email.val(userEmailId + '@' + selectVal);
				}
				
				validation_email.validate(["userEmailId"]);
			});

            $('#userEmailId').on('keyup',function(e,data){
                var val = $(this).val();
                val = vcui.string.replaceAll(val, ' ', '');
                $(this).val(val);
            });

			$('#userEmailId').on('keydown',function(e,data){
            	if(e.which === vcui.keyCode.SPACE){
                    $(this).val($(this).val().replace(/^\s+/,""));
                    return false;
                }
            });

			//카테고리
			self.$modelSelectBox.find('#categorySelect').on('change', function(){
				self.$modelSelectBox.find('.btn-prod-next').prop('disabled', true); // 버튼 비활성화

                var superCate = $(this).find('option:selected').data('category-name');

                if(superCate == "all") {
                    self.$modelSelectBox.find('#subCategorySelect').find('option:not(:first-child)').remove();
                    self.$modelSelectBox.find('#subCategorySelect').vcSelectbox('update');
                }
				
			});
			//서브 카테고리
			self.$modelSelectBox.find('#subCategorySelect').on('change', function(){
				var $this = $(this);
				var superCate = $this.find('option:selected').val();
				
				if(superCate !== "all") {
					
					$("#subCategory").val(superCate);
					$("#subCategoryNm").val($this.find('option:selected').text());

					self.$modelSelectBox.find('.btn-prod-next').prop('disabled', false);

				}
			});

			//modelSearchBox 카테고리
			self.$modelSearchBox.find('#prodCategorySelect').on('change', function(){
				self.$modelSearchBox.find('.btn-prod-next').prop('disabled', true); // 버튼 비활성화

                var val = $(this).find('option:selected').data('category-name');
                if(val !== "all") {
                    $("#subCategory").val("");
                    $("#subCategoryNm").val("");
                    
                }
			});
			//modelSearchBox 서브 카테고리
			self.$modelSearchBox.find('#prodSubCategorySelect').on('change', function(){
				var $this = $(this);
				var val = $this.find('option:selected').val();
                var nm = $this.find('option:selected').text();
                $("#subCategory").val(val);
                $("#subCategoryNm").val(nm);
				
				if(val !== "all") {
					self.validateModelSelectBox();

				}
			});

			//BTOCSITE-62364 모델번호, 제조번호 입력
			$('.prod-model-box').on('click', '.btn-prod-open', function() {
				var $this = $(this);
				var idx = $this.parents('.prod-model-box').index();

				if($this.parents('.prod-model-box').hasClass('open')) return;

				$('.prod-model-box').removeClass('open');
				$('.prod-model-box').eq(idx).addClass('open');
				
				switch (idx){
					case 0: //모델명/제조번호 선택
						$('#categoryNm').val("");
						$('#subCategoryNm').val("");
						$('#category').val("");
						$('#subCategory').val("");
						self.$modelSelectBox.find('[id="categorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
						self.$modelSelectBox.find('[id="subCategorySelect"]').children('option:not(:first-child)').remove();
						self.$modelSelectBox.find('[id="subCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
						break;
					case 1: //제품군 선택
						$('#categoryNm').val("");
						$('#subCategoryNm').val("");
						$('#category').val("");
						$('#subCategory').val("");
						$('#modelCode').val("");
						$('#productCode').val("");
						$('#salesModelCode').val("");
						$('#serialNumber').val("");
						self.$modelSearchBox.find('input[type="text"]').val("");
						self.$modelSearchBox.find('.success-msg').hide();
						//BTOCSITE-80487 고객지원 > 출장예약 > 모델명 입력 > 자동완성 미선택
						self.$modelSearchBox.find('[id="prodCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
						self.$modelSearchBox.find('[id="prodSubCategorySelect"]').children('option:not(:first-child)').remove();
						self.$modelSearchBox.find('[id="prodSubCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
						break;
				}
					
				$('.prod-model-box').eq(idx).find('.btn-prod-next').prop('disabled', true);
			});

			//BTOCSITE-62364 모델번호, 제조번호 입력
			$('.prod-model-box').on('click', '.btn-prod-next', function() {
				var $this = $(this);
				var idx = $this.parents('.prod-model-box').index();

				switch (idx){
					case 0: //모델명/제조번호 입력
						$('.success-msg').hide();
						var snVal = self.$modelSearchBox.find('input[name="sn"]').val();
						$('#serialNumber').val(snVal);
						var modelCode = self.$modelSearchBox.find('input[id="search"]').val().toUpperCase();
						$('#modelCode').val(modelCode);
					
						var param = {
							modelCode: modelCode,
						}
						$.extend(self.param, param);

						self.$cont.vcSearchModelNew('updateSummary', {
						    product: [self.param.categoryNm, self.param.subCategoryNm, self.param.modelCode],
						    reset: 'product'
						});

						break;
					case 1: //제품군 선택
						break;
				}
				//self.$selectedModelBar.show();
				self.$stepArea.show();
				self.$stepInput.show();
				self.$prodWrap.hide();
				//self.$searchArea.hide();
				$('#tabs-prod').hide();
			});

			// BTOCSITE-62364 모델번호, 제조번호 입력
			self.$modelSearchBox.on('keyup', 'input[name="sn"]', function(e) {
				self.validateModelSelectBox();
		
			});

            self.$modelSearchBox.on('focusout', 'input[id="search"]', function(e) {
				e.preventDefault();
                var searchVal = $(this).val().toUpperCase();
				var chkdata = self.$modelSearchBox.find('.keyword-list').find('li').find('[data-model-code="'+searchVal+'"]');
                
                if(chkdata.length > 0){
                    chkdata.trigger('click');

					self.$modelSearchBox.find('[id="prodCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
					self.$modelSearchBox.find('[id="prodSubCategorySelect"]').children('option:not(:first-child)').remove();
					self.$modelSearchBox.find('[id="prodSubCategorySelect"]').prop('selectedIndex', 0).vcSelectbox('update');
                }
            });
			
            self.$modelSearchBox.on('keyup', 'input[id="search"]', function(e) {
				e.preventDefault();

                var searchVal = $(this).val().toUpperCase();
				var chkdata = self.$modelSearchBox.find('.keyword-list').find('li').find('[data-model-code="'+searchVal+'"]');
                $(this).val(searchVal);

				var salesModelCode = $('#salesModelCode').val();
				if((e.keyCode === vcui.keyCode.BACKSPACE && salesModelCode != '') || (chkdata.length == 0 && salesModelCode != '')) {
					//모델명 조회 후 백스페이스 삭제
					$('#modelCode').val("");
					$('#productCode').val("");
					$('#salesModelCode').val("");
					$('#category').val("");
					$('#categoryNm').val("");
					$('#subCategory').val("");
					$('#subCategoryNm').val("");
				}

				if (e.keyCode == 13) {  
					if(chkdata.length > 0){
						chkdata.trigger('click');
					}
				}

				self.validateModelSelectBox();
            });

            self.$modelSearchBox.find('.btn-search').on('click', function(e) {
				e.preventDefault();
                var searchVal = $('#search').val().toUpperCase();
				var chkdata = self.$modelSearchBox.find('.keyword-list').find('li').find('[data-model-code="'+searchVal+'"]');
				
				if(chkdata.length > 0){
					chkdata.trigger('click');           
				}
            });
			
			self.$modelSearchBox.on('click', '.btn-delete', function(e) {
				self.$modelSearchBox.find('input[type="text"]').val('');

				self.delModelValue();
				self.validateModelSelectBox();
			});
			
			////상담 예약/문의  제품목록에서 선택 에서 모델명검색으로 모델선택
			self.$modelSearchBox.on('click', '.search-layer .autocomplete-box a', function(e) {   

				//$('#stepInput').addClass('active');
				//$('#stepInput').show();
				//$('#tabs-prod').hide();

				// BTOCSITE-62364 모델번호, 제조번호 입력
				 $('.keyword-search').removeClass('on');
				 setTimeout(function(){
                    self.validateModelSelectBox();
                }, 100);
			}); 
			
			//증상 1댑스 클릭
			self.$solutionsFilter.on('change', '.rdo-wrap', function(e, data) {
				self.$solutionsFilterSub1.hide();
				self.$solutionsFilterSub2.hide();
				self.$solutionsFilterSub1.find('select').prop('selectedIndex', 0).vcSelectbox('update');
				self.$solutionsFilterSub2.find('select').prop('selectedIndex', 0).vcSelectbox('update');
				self.$menuList.hide().find('.select-service li').removeClass('on');
				$('.service-include-wrap').hide();
				
				var value = $(this).find('input[type=radio]').attr('value');
				var name = $(this).find('input[type=radio]').data('name');
				$('#sympCd').val(value); 
				$('#sympCdNm').val(name);
				$('#sympSubCode').val('');
				$('#sympSubCodeNm').val('');
				$('#sympCodeThree').val('');
				$('#sympCodeThreeNm').val('');
				var param = {
						topic:value,
						topicNm:name,
						subTopic:'',
						subTopicNm:'전체',
						sympCodeThree: '',
						sympNameThreeNm: '전체',
						productCode:  $('#productCode').val()
						
				};
				$.extend(self.param, param);
				var htmlPC= "";
				var symp2url = "/support/commonModelSelectedTwo.lgajax?";
				lgkorUI.requestAjaxData(symp2url, self.param, function(result) {
					var arr = result.data.subTopicList instanceof Array ? result.data.subTopicList : [];
					
					arr.forEach(function(item) {
						item.subType = true;
						item.active = item.name == param.subTopicNm ? true : false; 
						//htmlPC += vcui.template(filterTemplate, item);
						htmlPC += vcui.template(filterSubTemplate, item);
						//htmlM += vcui.template(filterOptionTemplate, item);
					});
					
					htmlPC = '<option data-code="" data-text="" value="" class="placeholder">증상을 선택해 주세요.</option>' + htmlPC;
					//htmlPC = '<select class="ui_selectbox" title="증상선택">'+htmlPC+'</select>';
					self.$solutionsFilterSub1.find('select').html(htmlPC).vcSelectbox('update');
					self.$solutionsFilterSubtopic.show();
					self.$solutionsFilterSub1.show();
					//select4.find('.ui-selectbox-wrap').addClass('on'); // 서브 카테고리 자동 열림
					//self.$solutionsFilterSub1.find('select').vcSelectbox();
					lgkorUI.hideLoading();
					$('#stopic01').find('.ui-selectbox-wrap').addClass('on');
					$('#stopic01').find('.ui-selectbox-wrap').find('.ui-selectbox-list').show();
					//$('.err-msg.sup-topic-all-msg').html("정확한 세부 증상을 선택해 주세요.");
				},'GET');
				//$('.err-msg.sup-topic-all-msg').show();
			});

			self.$solutionsFilterSub1.on('change' ,'.ui_selectbox' , function(e, data) {
				var value = self.$solutionsFilterSub1.find("option:selected").attr("data-code");
				var name = self.$solutionsFilterSub1.find("option:selected").attr("data-text");
				$('#sympSubCode').val(value);
				$('#sympSubCodeNm').val(name);
				$('#sympCodeThree').val('');
				$('#sympCodeThreeNm').val('');
				self.$menuList.hide().find('.select-service li').removeClass('on');
				$('.service-include-wrap').hide();

				var param = {
						subTopic:value,
						subTopicNm:name,
						sympCodeThree: '',
						sympNameThreeNm: '전체'
				};
				$.extend(self.param, param);
				var htmlPC = "";
				// var select5 = self.$cont.find("#stopic02");
				// if(select5 != null){
				// 	//select5.attr("class", "select-wrap");
				// 	select5.html("세부 증상을 선택해 주세요");
				// }
				$('#video').prop('checked', false);
				lgkorUI.showLoading();
				var symp3url = "/support/commonModelSelectedThree.lgajax?";
				lgkorUI.requestAjaxData(symp3url, self.param, function(result) {
				
					var arr = result.data.threeTopicList instanceof Array ? result.data.threeTopicList : [];
		  
					arr.forEach(function(item) {
						item.subType = true;
						item.active = item.name == param.subTopicNm ? true : false; 
						htmlPC += vcui.template(filterSubTemplate, item);
					});
					
					htmlPC = '<option data-code="" data-text="" value="" class="placeholder">증상을 선택해 주세요</option>' + htmlPC;
					//htmlPC = '<select class="ui_selectbox" title="증상선택">'+htmlPC+'</select>';
					self.$solutionsFilterSub2.find('select').html(htmlPC).vcSelectbox('update');
					self.$solutionsFilterSubtopic.show();
					self.$solutionsFilterSub2.show();
					// self.$solutionsFilterSub2.find('select').vcSelectbox();
					//BTOCSITE-59670 고객지원 > 증상 선택시 2depth와 3depth 동일 증상이면 선택 예외처리 요청
					var timeout = null;
					if(arr.length === 1) {
						self.$solutionsFilterSub2.find('select').vcSelectbox('selectedIndex', 1, true);
						clearTimeout(timeout);
						timeout = setTimeout(function() {
							self.$solutionsFilterSub2.find('select').vcSelectbox('update');
							self.$solutionsFilterSub2.trigger('click');	
						}, 10);
					}
					
					
					lgkorUI.hideLoading();
					$('#stopic02').find('.ui-selectbox-wrap').addClass('on');
					$('#stopic02').find('.ui-selectbox-wrap').find('.ui-selectbox-list').show();
				},'GET');
			});
			//증상 3 선택
			self.$solutionsFilterSub2.on('change', '.ui_selectbox', function(e, data) { //증상3 선택
				var value = self.$solutionsFilterSub2.find("option:selected").attr("data-code");
				var name = self.$solutionsFilterSub2.find("option:selected").attr("data-text");
				$('#sympCodeThree').val(value); 
				$('#sympCodeThreeNm').val(name);
				$('#video').prop('checked', false);
				self.param.keywords = [];
				self.param.keyword = '';
				var param = {
						sympCodeThree:value,
						sympCodeThree:name
				};
				$.extend(self.param, param);
				var url = "/support/smplSolCnt.lgajax?";
				var urlParam = "&topic=" + $("div.step-area input#sympCd").val()
						  + "&subTopic=" + $("div.step-area input#sympSubCode").val()
						  + "&sympCodeThree=" + $("div.step-area input#sympCodeThree").val()
						  + "&productCode=" + $("div.step-area input#productCode").val();
				lgkorUI.showLoading();
				$.ajax({
					type: "GET",
					async: true,
					url: url+urlParam, 
					success: function(result){
						if(result.data.solutionFlag){
							$("div#solutionBanner").show();
							$("div#solutionBanner").find('.btn-link').html("상담 예약/문의 계속하기");
						}else{
							// 챗봇 비노출
							$("div#solutionBanner").hide();
						}
						
						lgkorUI.hideLoading();
					},
					error:function(){
						lgkorUI.hideLoading();
					}
				});
				lgkorUI.scrollTo($('#addDesc'));
				self.$menuList.show();
			});

            self.$textarea.on('focusout', function(){
				
				//BTOCSITE-84932 (WAF 이슈 대응) 고객문의글에 개인정보 Pattern 인식 시, Alert 적용
				self.checkTextarea('#addDesc textarea', '#onlineServiceMenu');
            });
            self.$inquiryContent.on('focusout', function(){
				
				//BTOCSITE-84932 (WAF 이슈 대응) 고객문의글에 개인정보 Pattern 인식 시, Alert 적용
				self.checkTextarea('#inquiryBox textarea', '#service-email .btn-complete');
            });
			
        
			
			self.$solutionsBanner.find('.btn-link').on('click', function(){
				self.$solutionsBanner.hide();
				lgkorUI.scrollTo($('.select-service'));
			});
			
			self.$solutionsBanner.find('.btn-chatbot').on('click', function(){
			   var subTopic =  $('#stopic02 option:selected').text();
			   var speech = $('#subCategoryNm').val() + ' ' + subTopic;
			   var chatUrl = lgkorUI.getChatDomain() + "/kr/index.html?service=cs&speech=" + encodeURIComponent(speech);
			   //var chatUrl = "https://chat-qa.lgechat.co.kr/?service=cs&speech=" + encodeURIComponent(speech);
			   lgkorUI.getChatPinCodeAsUrl(chatUrl, 450, 760);
			});
		  
			self.$servicecall.on('click', '.btn-cal', function(){       //전화 상담 예약 일정 수정
				self.$servicecall.find('.change-dt').show();
				self.$servicecall.find('.info-wrap').hide();
				self.$servicecall.find('.section.date-info-wrap.accord-wrap').hide();
				
			});
			self.$servicecall.on('click', '.btn-comp', function(){       //전화 상담 예약 일정 확정
				$('#date').val($('#fastdate').val());
				$('#time').val($('#fasttime').val());
				var fdate = dateUtil.format($('#fastdate').val() + '' + $('#fasttime').val() + '00', 'yyyy년 MM월 dd일 hh시 mm분');
				var target = $('#serviceName').val();
				$('#'+target).find('.check-info').find('.date').html(fdate);
				self.$servicecall.find('.btn-confirm').trigger('click');  //예약 완료 진행
			});
			
			self.$serviceremote.on('click', '.btn-cal', function(){       //원격 상담 예약 일정 수정
				self.$serviceremote.find('.change-dt').show();
				self.$serviceremote.find('.info-wrap').hide();
				self.$serviceremote.find('.section.date-info-wrap.accord-wrap').hide();
				
			});
			self.$serviceremote.on('click', '.btn-comp', function(){       //원격 상담 예약 일정 확정
				$('#date').val($('#fastdate').val());
				$('#time').val($('#fasttime').val());
				var fdate = dateUtil.format($('#fastdate').val() + '' + $('#fasttime').val() + '00', 'yyyy년 MM월 dd일 hh시 mm분');
				var target = $('#serviceName').val();
				$('#'+target).find('.check-info').find('.date').html(fdate);
				self.$serviceremote.find('.btn-confirm').trigger('click');     //예약 완료 진행
			});
			
			self.$servicevideo.on('click', '.btn-cal', function(){       //영상 상담 예약 일정 수정
				self.$servicevideo.find('.change-dt').show();
				self.$servicevideo.find('.info-wrap').hide();
				self.$servicevideo.find('.section.date-info-wrap.accord-wrap').hide();
				
			});
			self.$servicevideo.on('click', '.btn-comp', function(){       //영상 상담 예약 일정 확정
				
				$('#date').val($('#fastdate').val());
				$('#time').val($('#fasttime').val());
				var fdate = dateUtil.format($('#fastdate').val() + '' + $('#fasttime').val() + '00', 'yyyy년 MM월 dd일 hh시 mm분');
				var target = $('#serviceName').val();
				$('#'+target).find('.check-info').find('.date').html(fdate);
				
				self.$servicevideo.find('.btn-confirm').trigger('click');      //예약 완료 진행
			});
			
			self.$inquiryList.on('click', function(){
				if($('#inquiryList').find('input[type=radio]:checked').length == 1){  //문의 유형 선택관련 채크
					$('.err-msg.type-msg').hide();
				}
				
			});
			  //모델입력 앤터 처리
			// self.$modelSearchBox.on('keyup', 'input[id=search]', function(e) {
			// 	//영문이나 숫자로 이루어진 모델명을 2자 이상 입력해 주세요.
			// 	self.$modelSearchBox.find('.search-error').html('영문이나 숫자로 이루어진 모델명을 2자 이상 입력해 주세요.');
			// 	self.$modelSearchBox.find('.search-error').hide();
			// 	if (e.keyCode == 13) {  
			// 		e.preventDefault();
			// 		var chkdata = self.$modelSearchBox.find('.keyword-list').find('li').find('a').attr('data-model-code');
			// 		if($('#search').val().toUpperCase() == chkdata){
			// 			self.$modelSearchBox.find('.keyword-list').find('li').find('a').trigger('click');                    
			// 		}else{
			// 			self.$modelSearchBox.find('.search-error').html('"'+$('#search').val().toUpperCase()+'"에 대한 검색 결과가 없습니다.')
			// 			self.$modelSearchBox.find('.search-error').show();
			// 		}
			// 	}
			// });
			// self.$modelSearchBox.find('.btn-search').on('click', function(e){
			// 	e.preventDefault();
			// 	var chkdata = self.$modelSearchBox.find('.keyword-list').find('li').find('a').attr('data-model-code');
			// 	if($('#search').val().toUpperCase() == chkdata){
			// 		self.$modelSearchBox.find('.keyword-list').find('li').find('a').trigger('click');                    
			// 	}else{
			// 		self.$modelSearchBox.find('.search-error').html('"'+$('#search').val().toUpperCase()+'"에 대한 검색 결과가 없습니다.')
			// 		self.$modelSearchBox.find('.search-error').show();
			// 	}
			// });
			// BTOCSITE-51309 1:1 문의 & 이메일 문의] 휴대폰 번호 입력 항목 추가
			/* $('#userEmail2select').on('change', function(){   //이메일 선텍시 체크
				var selectVal = $('#userEmailSelect option:selected').val();
				var userEmail = $('#userEmail').val();
				var userEmailDir = $('#userEmailDirect').val();
				
				if(selectVal == '') {
					$('#userEmailError').show();
				}else if(selectVal == "direct"){
					$('#userEmailError').show();
				}else{
					if($.trim(userEmail) == ''){
						$('#userEmailError').show();
					// }else{
					// 	$('#userEmailError').hide();
					}
				};
				
				
				validation_email.validate(["userEmail"]);
				
			}); */
			
		}
		
	}
	$(window).ready(function() {
		reservation.init();
		//상담 예약/문의에서만 전달사항 문구 변경
		//$('textarea#content').attr('placeholder', "서비스 전문 상담사에게 전달할 내용을 입력해 주세요.\n - 증상이 여러 개일 경우, 선택하신 대표 증상 외의 추가 상황을 이곳에 작성해 주세요.\n ※ 개인 정보를 입력하지 않도록 유의해 주세요. (전화번호, 주소 등)");
		var preLoad = {
				category:$('input#category').val(),
				subCategory:$('input#subCategory').val()
		}
		if(preLoad.category != '' && preLoad.subCategory != ''){
			$('div.section.accord-wrap.prod-selected-box.prod-search-wrap').hide();
			$('div#stepInput').show();
			//$('.goods-selected-wrap').show();
			$('#tabs-prod').hide();
		}
	});
})();